import { EntityDialog, AddBtn, IconBtn } from "@/components/admin/shared";
import { Pencil, Trash2, ChevronUp, ChevronDown } from "lucide-react";

export default function SponsorsPanel({ sponsors, sponsorFields, saveSponsor, moveSponsor, del, setSponsors }) {
  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <p className="text-xs text-slate-500">Trascina l'ordine con le frecce ↑↓. Il logo si carica direttamente (no URL). Gli inserzionisti appaiono nella striscia "La nostra Pubblicità".</p>
        <EntityDialog title="Nuovo inserzionista" fields={sponsorFields} initial={{ slot: "inline", order: sponsors.length }} onSave={saveSponsor} trigger={<AddBtn data-testid="add-sponsor-btn" />} />
      </div>
      <div className="space-y-2">
        {sponsors.map((s, idx) => (
          <div key={s.id} className="flex items-center gap-3 p-3 rounded-sm border border-slate-200 dark:border-slate-800 bg-white dark:bg-legend-paper">
            <div className="flex flex-col">
              <IconBtn data-testid={`sponsor-up-${s.id}`} onClick={() => moveSponsor(idx, -1)} title="Su"><ChevronUp size={14} /></IconBtn>
              <IconBtn data-testid={`sponsor-down-${s.id}`} onClick={() => moveSponsor(idx, 1)} title="Giù"><ChevronDown size={14} /></IconBtn>
            </div>
            {s.logo ? <img src={s.logo} alt="" className="w-16 h-10 object-contain bg-white rounded-sm" /> : <div className="w-16 h-10 grid place-items-center bg-slate-100 dark:bg-white/5 rounded-sm text-[10px] text-slate-400">no logo</div>}
            <div className="flex-1"><p className="font-display font-bold uppercase text-sm">{s.name}</p><p className="text-xs text-slate-500">#{idx} · {s.slot} · {s.tagline}</p></div>
            <EntityDialog title="Modifica inserzionista" fields={sponsorFields} initial={s} onSave={saveSponsor} trigger={<IconBtn data-testid={`edit-sponsor-${s.id}`}><Pencil size={15} /></IconBtn>} />
            <IconBtn data-testid={`delete-sponsor-${s.id}`} onClick={() => del("/admin/sponsors", s.id, setSponsors, sponsors)}><Trash2 size={15} /></IconBtn>
          </div>
        ))}
      </div>
    </>
  );
}
